import { render, staticRenderFns } from "./iujp.vue?vue&type=template&id=47a5f07f&scoped=true&"
import script from "./iujp.vue?vue&type=script&lang=js&"
export * from "./iujp.vue?vue&type=script&lang=js&"
import style0 from "./iujp.vue?vue&type=style&index=0&id=47a5f07f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5f07f",
  null
  
)

export default component.exports